<div class="container">
    <div class="our-services-row pt-80 pb-80">

        <div class="text-center ps-5 pe-5 res-plr-0">
            <h2 class="mb-3">Our Services</h2>
            <p>For over 20 years, Strait Air Transport has provided air transportation services worldwide. We specialize in all solutions related to the air freight business and offer full freight forwarding service to include ocean, sea/air, road and rail
                transport.</p>
            <!-- <p>For over 20 years, Strait Air Transport has provided air transportation and air transportation services throughout Europe. </p>
            <p>We specialize in all solutions related to the air freight business including direct services, full and split charters, express & courier services, project handling, warehousing & distribution, customs clearance, and consolidation services.
                Additionally, we offer ocean freight, ocean/air, and road transport.</p> -->
        </div>

        <div class="pt-3">
            <div class="row">
                <div class="col-lg-6">
                    <div class="card d-none d-md-block">
                        <div class="card-body">
                            <div class="left-col">
                                <h4 class="card-title">Air Services</h4>
                                <ul class="ps-3">
                                    <li>
                                        <div [routerLink]="['/air-service']" fragment="air-freight">
                                            <a href="air-service#air-freight"><span class="list-number">01.</span>Air Freight</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div [routerLink]="['/air-service']" fragment="express">
                                            <a href="air-service#express"><span class="list-number">02.</span>Express</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div [routerLink]="['/air-service']" fragment="charter">
                                            <a href="air-service#charter"><span class="list-number">03.</span>Charter</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div [routerLink]="['/air-service']" fragment="obc">
                                            <a href="air-service#obc"><span class="list-number">04.</span>On Board Courier</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div [routerLink]="['/air-service']" fragment="sea-air">
                                            <a href="air-service#sea-air"><span class="list-number">05.</span>Sea/Air</a>
                                        </div>
                                    </li>
                                </ul>
                                <a class="more-link" routerLink="air-service">More</a>
                            </div>
                            <div class="right-col d-flex justify-content-end">
                                <img src="../assets/images/our-services/air-services.png" alt="air-services" class="img-fluid img-after">
                            </div>
                        </div>
                    </div>

                    <div class="card mobile-card d-md-none">
                        <div class="card-body">
                            <img src="assets/images/our-services/air-service-mobile.png" alt="air-service-card" class="img-fluid w-100">
                            <div class="left-col">
                                <h4 class="card-title">Air Services</h4>
                                <ul class="ps-3 d-flex">
                                    <span class="pe-5">
                                             <li>
                                                  <div [routerLink]="['/air-service']" fragment="air-freight">
                                                       <a href="air-service#air-freight"><span class="list-number">01.</span>Air Freight</a>
                            </div>
                            </li>
                            <li>
                                <div [routerLink]="['/air-service']" fragment="express">
                                    <a href="air-service#express"><span class="list-number">02.</span>Express</a>
                                </div>
                            </li>
                            <li>
                                <div [routerLink]="['/air-service']" fragment="charter">
                                    <a href="air-service#charter"><span class="list-number">03.</span>Charter</a>
                                </div>
                            </li>
                            </span>
                            <span>
                                             <li>
                                                  <div [routerLink]="['/air-service']" fragment="obc">
                                                       <a href="air-service#obc"><span class="list-number">04.</span>On Board Courier</a>
                        </div>
                        </li>
                        <li>
                            <div [routerLink]="['/air-service']" fragment="sea-air">
                                <a href="air-service#sea-air"><span class="list-number">05.</span>Sea/Air</a>
                            </div>
                        </li>
                        </span>
                        </ul>
                        <a class="more-link" routerLink="air-service">More</a>
                        <img src="../assets/images/our-services/mobile-card-bg.png" alt="air-services-card" class="img-fluid mobile-card-bg">
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="card d-none d-md-block">
                <div class="card-body">
                    <div class="left-col">
                        <h4 class="card-title">Ocean Services</h4>
                        <ul class="ps-3">
                            <li>
                                <div [routerLink]="['/ocean-service']" fragment="lcl">
                                    <a href="ocean-service#lcl"><span class="list-number">01.</span>Less than Container Load</a>
                                </div>
                            </li>
                            <li>
                                <div [routerLink]="['/ocean-service']" fragment="fcl">
                                    <a href="ocean-service#fcl"><span class="list-number">02.</span>Full Container Load</a>
                                </div>
                            </li>
                            <li>
                                <div [routerLink]="['/ocean-service']" fragment="rail-transport">
                                    <a href="ocean-service#rail-transport"><span class="list-number">03.</span>Rail Transport</a>
                                </div>
                            </li>
                        </ul>
                        <a class="more-link" routerLink="ocean-service">More</a>
                    </div>
                    <div class="right-col d-flex justify-content-end">
                        <img src="../assets/images/our-services/ocean-service-card-shape.png" alt="ocean-service-card" class="img-fluid img-after">
                    </div>
                </div>
            </div>

            <div class="card mobile-card d-md-none">
                <div class="card-body">
                    <img src="assets/images/our-services/ocean-service-mobile.png" alt="ocean-service-card" class="img-fluid w-100">
                    <div class="left-col">
                        <h4 class="card-title">Ocean Services</h4>
                        <ul class="ps-3 d-flex">
                            <span class="pe-5">
                                         <li>
                                             <div [routerLink]="['/ocean-service']" fragment="lcl">
                                                  <a href="ocean-service#lcl"><span class="list-number">01.</span>Less than Container Load</a>
                    </div>
                    </li>
                    <li>
                        <div [routerLink]="['/ocean-service']" fragment="fcl">
                            <a href="ocean-service#fcl"><span class="list-number">02.</span>Full Container Load</a>
                        </div>
                    </li>
                    <li>
                        <div [routerLink]="['/ocean-service']" fragment="rail-transport">
                            <a href="ocean-service#rail-transport"><span class="list-number">03.</span>Rail</a>
                        </div>
                    </li>
                    </span>
                    </ul>
                    <a class="more-link" routerLink="air-service">More</a>
                    <img src="../assets/images/our-services/mobile-card-bg.png" alt="air-services" class="img-fluid mobile-card-bg">
                </div>

            </div>
        </div>
    </div>


</div>

<div class="row">
    <div class="col-lg-6">
        <div class="card mb-0 d-none d-md-block">
            <div class="card-body">
                <div class="left-col">
                    <h4 class="card-title">Verticals</h4>
                    <ul class="ps-3">
                        <li>
                            <div [routerLink]="['/verticals']" fragment="aviation-logistics">
                                <a href="verticals#aviation-logistics"><span class="list-number">01.</span>Aviation Logistics</a>
                            </div>
                        </li>
                        <li>
                            <div [routerLink]="['/verticals']" fragment="marine-logistics">
                                <a href="verticals#marine-logistics"><span class="list-number">02.</span>Marine Logistics</a>
                            </div>
                        </li>
                        <li>
                            <div [routerLink]="['/verticals']" fragment="fasion-logistics">
                                <a href="verticals#fasion-logistics"><span class="list-number">03.</span>Fashion Logistics</a>
                            </div>
                        </li>
                    </ul>
                    <a class="more-link" routerLink="verticals">More</a>
                </div>
                <div class="right-col d-flex justify-content-end">
                    <img src="../assets/images/our-services/verticals-card.png" alt="value-added-services" class="img-fluid img-after">
                </div>
            </div>
        </div>

        <div class="card mobile-card d-md-none">
            <div class="card-body">
                <img src="assets/images/our-services/verticals-banner.png" alt="air service" class="img-fluid w-100">
                <div class="left-col">
                    <h4 class="card-title">Verticals</h4>
                    <ul class="ps-3 d-flex">
                        <span class="pe-5">
                                         <li>
                                             <div [routerLink]="['/verticals']" fragment="aviation-logistics">
                                                  <a href="verticals#aviation-logistics"><span class="list-number">01.</span>Aviation Logistics</a>
                </div>
                </li>
                <li>
                    <div [routerLink]="['/verticals']" fragment="marine-logistics">
                        <a href="verticals#marine-logistics"><span class="list-number">02.</span>Marine Logistics</a>
                    </div>
                </li>
                <li>
                    <div [routerLink]="['/verticals']" fragment="fasion-logistics">
                        <a href="verticals#fasion-logistics"><span class="list-number">03.</span>Fashion Logistics</a>
                    </div>
                </li>
                </span>
                </ul>
                <a class="more-link" routerLink="air-service">More</a>
                <img src="../assets/images/our-services/mobile-card-bg.png" alt="air-services" class="img-fluid mobile-card-bg">
            </div>

        </div>
    </div>
</div>
<div class="col-lg-6">
    <div class="card mb-0 d-none d-md-block">
        <div class="card-body">
            <div class="left-col">
                <h4 class="card-title">Value Added <br>Services</h4>
                <ul class="ps-3 large-text">
                    <li>
                        <div [routerLink]="['/value-added-service']" fragment="cargo-insurance">
                            <a href="value-added-service#cargo-insurance"><span class="list-number">01.</span>Cargo Insurance</a>
                        </div>
                    </li>
                    <li>
                        <div [routerLink]="['/value-added-service']" fragment="customs-clearance">
                            <a href="value-added-service#customs-clearance"><span class="list-number">02.</span>Customs Clearance</a>
                        </div>
                    </li>
                </ul>
                <a class="more-link" routerLink="value-added-service">More</a>
            </div>
            <div class="right-col d-flex justify-content-end">
                <img src="../assets/images/our-services/value-added-services.png" alt="value-added-services" class="img-fluid img-after">
            </div>
        </div>
    </div>

    <div class="card mobile-card d-md-none">
        <div class="card-body">
            <img src="assets/images/our-services/value-service-mobile.png" alt="air service" class="img-fluid w-100">
            <div class="left-col">
                <h4 class="card-title">Value Added Services</h4>
                <ul class="ps-3 d-flex">
                    <span class="pe-5">
                                         <li>
                                             <div [routerLink]="['/value-added-service']" fragment="cargo-insurance">
                                                  <a href="value-added-service#cargo-insurance"><span class="list-number">01.</span>Cargo Insurance</a>
            </div>
            </li>
            <li>
                <div [routerLink]="['/value-added-service']" fragment="customs-clearance">
                    <a href="value-added-service#customs-clearance"><span class="list-number">02.</span>Customs Clearance</a>
                </div>
            </li>
            </span>
            </ul>
            <a class="more-link" routerLink="air-service">More</a>
            <img src="../assets/images/our-services/mobile-card-bg.png" alt="air-services" class="img-fluid mobile-card-bg">
        </div>

    </div>
</div>
</div>


</div>
</div>
</div>
</div>